import { useContext, useMemo } from "react";
import { AirCoolerContext } from "../context/AirCoolerContext";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./FirstStageSeparator.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import AirCooler from "../components/AirCooler";
import AirCoolerFaceplate from "../components/AirCoolerFaceplate";

import { trackPageVisit } from "../competency/PageTracker";







function AirCoolerPage() {
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    setOpenPanels((prev) =>
      prev.includes(tag) ? prev : [...prev, tag]
    );
  };

  const closePanel = (tag) => {
    setOpenPanels((prev) => prev.filter((p) => p !== tag));
  };

  return (
    <div>
      <AirCooler tag="A-101A" x={300} y={200} onClick={openPanel} />
      <AirCooler tag="A-101B" x={500} y={200} onClick={openPanel} />
      <AirCooler tag="A-102A" x={300} y={200} onClick={openPanel} />
      <AirCooler tag="A-102B" x={500} y={200} onClick={openPanel} />

      {openPanels.map((tag, i) => (
        <AirCoolerFaceplate
          key={tag}
          tag={tag}
          close={() => closePanel(tag)}
          defaultPosition={{ x: 300 + i * 40, y: 120 + i * 40 }}
        />
      ))}
    </div>
  );
}


 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }

          


function FirstStageSeparator() {

        useEffect(() => {
  
    trackPageVisit("FirstStageSeparator");
  
  }, []);

  const {  valves, toggleValve, transmitters} = useContext(WellContext);

  const { levels } = useContext(WellContext);
  // ================= LEVEL FLOW LOGIC =================

      // INFLOW INTO FIRST STAGE
      const inflow_120 =
        valves?.XV_12001 === false
          ? (transmitters?.MPFT_10501 || 0) / 20
          : 0;

      // FLOW GOING TO SECOND STAGE
      const FIC_14001 =
        valves?.XV_14001 === false
          ? (transmitters?.FIC_12007 || 0)
          : 0;

      const flow_120_to_140 =
        valves?.XV_14001 === false
          ? FIC_14001 / 60
          : 0;

  const DEFAULT_VALVES = {
  FCV_12001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12002: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12003: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12004: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12005: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12006: { mode: "Manual", opening: 0, sp: "", pv: "" },
};

  /* ================= SINGLE CLEAN STATE (FIXED) ================= */
  const [valveData, setValveData] = useState(() => {
    const saved = localStorage.getItem("FirstStageSeparator_valveData");

    if (!saved) return DEFAULT_VALVES;

    try {
      const parsed = JSON.parse(saved);

      const merged = {};
      Object.keys(DEFAULT_VALVES).forEach((key) => {
        merged[key] = {
          ...DEFAULT_VALVES[key],
          ...(parsed?.[key] || {}),
        };
      });

      return merged;
    } catch {
      return DEFAULT_VALVES;
    }
  });

  /* ================= SAVE ================= */
  useEffect(() => {
    localStorage.setItem(
      "FirstStageSeparator_valveData",
      JSON.stringify(valveData)
    );
  }, [valveData]);


  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels, A101] = useState([]);

const openPanel = (tag) => {
    setOpenPanels((prev) =>
      prev.includes(tag) ? prev : [...prev, tag]
    );
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };

const [openCoolerPanels, setOpenCoolerPanels] = useState([]);

const openCoolerPanel = (tag) => {
  setOpenCoolerPanels((prev) =>
    prev.includes(tag) ? prev : [...prev, tag]
  );
};

const closeCoolerPanel = (tag) => {
  setOpenCoolerPanels((prev) => prev.filter((p) => p !== tag));
};

  
  // ================= INFLOW LOGIC from PRODUCTION HEADER-1 to FIRST STAGE SEPARATOR CRUDE LEVEL TRANSMITTER =================
      const [FIC_12003, setFIC_12003 ] = useState(() => {
        return Number(localStorage.getItem("FIC_12003")) || 0;
      }); 

      const isXV_12001Open = !valves?.XV_12001;

      const crudeFlow2 = Number(transmitters?.MPFT_10501 ?? 0);
      const waterFlow2 = Number(transmitters?.MPFT_10503 ?? 0);
      const gasFlow2 = Number(transmitters?.MPFT_10502 ?? 0);

      /* CRUDE INFLOW */
      const inflows3 = (isXV_12001Open && crudeFlow2 > 0)
        ? [crudeFlow2 / 60]
        : [];

      /* WATER INFLOW */
      const inflows4 = (isXV_12001Open && waterFlow2 > 0)
        ? [waterFlow2 / 20]
        : [];

      /* GAS TRANSMITTER */
      const FIC_12001 = isXV_12001Open ? gasFlow2 : 0;


      
        

        const isXV_12004Open = valves?.XV_12004 === false;
        

        // First flow (direct from FCV)
        const targetFIC_12003 = FIC_12001 * ((valveData?.FCV_12001?.opening || 0) / 100);

    useEffect(() => {
        const interval = setInterval(() => {
          setFIC_12003(prev => {
            const diff = targetFIC_12003 - prev;

            // smoothing factor (tune this)
            const step = diff * 0.1;

            // snap when very close
            if (Math.abs(diff) < 0.001) return targetFIC_12003;

            return prev + step;
          });
        }, 200); // speed of update

        return () => clearInterval(interval);
      }, [targetFIC_12003]);

      useEffect(() => {
            localStorage.setItem("FIC_12003", FIC_12003);
          }, [FIC_12003]);

      
         
       const FIC_12002 = ((valveData?.FCV_12002?.opening || 0) / 100) * Number(transmitters?.FIC_13003 ?? 0);
       const PT_12003 = ((valveData?.FCV_12002?.opening || 0) / 100) * Number(transmitters?.PT_13003 ?? 0);


        // Remaining gas after first split
        const FIC_12009 = (FIC_12001 - FIC_12003) + FIC_12002;



          // ================= FLOW from PRODUCTION HEADER-1 to FIRST STAGE SEPARATOR =================
              const [FIC_13001a, setFIC_13001a] = useState(() => {
                return Number(localStorage.getItem("FIC_13001a")) || 0;
              });   
              const targetFIC_13001a = useMemo(() => {
                const fic = Number(transmitters?.FIC_10501 ?? 0);
                return valves?.XV_12001 === false ? fic : 0.03;
              }, [transmitters?.FIC_10501, valves?.XV_12001]);
        
              useEffect(() => {
                const interval = setInterval(() => {
                  setFIC_13001a(prev => {
                    const diff = targetFIC_13001a - prev;
        
                    // smoothing factor (tune this)
                    const step = diff * 0.08;
        
                    // snap when very small difference
                    if (Math.abs(diff) < 0.001) return targetFIC_13001a;
        
                    return prev + step;
                  });
                }, 200); // update speed
        
                return () => clearInterval(interval);
              }, [targetFIC_13001a]);
        
              useEffect(() => {
                    localStorage.setItem("FIC_13001a", FIC_13001a);
                  }, [FIC_13001a]);


  // ================= DECREMENTING IMPURITY LEVEL OF FIRST STAGE SEPARATOR CHAMBER =================
        const impurityFlowRate1stStageSeparator = 250.675;
       const FIC_12005 = impurityFlowRate1stStageSeparator * ((valveData?.FCV_12003?.opening || 0) / 100);


  // ================= DECREMENTING IMPURITY LEVEL OF FIRST STAGE SEPARATOR CHAMBER =================
        const ReverseDemulsifier = 250.675;
       const FIC_12008 = ReverseDemulsifier * ((valveData?.FCV_12004?.opening || 0) / 100);

    








      // ===============================
      // A-101 AIR COOLER TRANSMITTER LOGIC
      // ===============================
      const { coolerData } = useContext(AirCoolerContext);
      // SAFELY GET COOLERS
      const a101A = coolerData?.["A-101A"] || { speed: 0, running: false };
      const a101B = coolerData?.["A-101B"] || { speed: 0, running: false };

      // RUNNING STATES
      const a101AOn = Boolean(a101A.running);
      const a101BOn = Boolean(a101B.running);

      // ===============================
      // SPEED (%)
      // ===============================
      let A101Speed = 0;

      if (a101AOn && a101BOn) {
        A101Speed = (a101A.speed + a101B.speed) / 2;
      } else if (a101AOn) {
        A101Speed = a101A.speed;
      } else if (a101BOn) {
        A101.Speed = a101B.speed;
      }

      // ===============================
      // RPM CALCULATION
      // ===============================
      const baseRPM = 1900;

      let A101RPM = 0;

      const rpmA = a101AOn ? (a101A.speed / 100) * baseRPM : 0;
      const rpmB = a101BOn ? (a101B.speed / 100) * baseRPM : 0;

      if (a101AOn && a101BOn) {
        A101RPM = (rpmA + rpmB) / 2;
      } else {
        A101RPM = rpmA + rpmB;
      }
        


      
      // ===============================
      // A-102 AIR COOLER TRANSMITTER LOGIC
      // ===============================
      // SAFELY GET COOLERS
      const a102A = coolerData?.["A-102A"] || { speed: 0, running: false };
      const a102B = coolerData?.["A-102B"] || { speed: 0, running: false };

      // RUNNING STATES
      const a102AOn = Boolean(a102A.running);
      const a102BOn = Boolean(a102B.running);

      // ===============================
      // SPEED (%)
      // ===============================
      let A102Speed = 0;

      if (a102AOn && a102BOn) {
        A102Speed = (a102A.speed + a102B.speed) / 2;
      } else if (a102AOn) {
        A102Speed = a102A.speed;
      } else if (a102BOn) {
        A102Speed = a102B.speed;
      }

      // ===============================
      // RPM CALCULATION
      // ===============================
      const base2RPM = 2400;

      let A102RPM = 0;

      const rpm2A = a102AOn ? (a102A.speed / 100) * base2RPM : 0;
      const rpm2B = a102BOn ? (a102B.speed / 100) * base2RPM : 0;

      if (a102AOn && a102BOn) {
        A102RPM = (rpm2A + rpm2B) / 2;
      } else {
        A102RPM = rpm2A + rpm2B;
      }


      // ===============================
      // AIR COOLER FLOW DISTRIBUTION (FIXED)
      // ===============================

      // DEFINE COOLER AVAILABILITY FROM EXISTING VARIABLES
      const A101_ON = a101AOn || a101BOn;
      const A102_ON = a102AOn || a102BOn;

      
      
      
      // ============= OUTPUT FLOWS ========================= //
      let FLOW_A101 = 0;
      let FLOW_A102 = 0;
      let FIC_12004 = 0;

      // ================= FINAL LOGIC =================

      // 🚫 VALVE CLOSED → NO FLOW
      if (!isXV_12004Open) {
        FLOW_A101 = 0;
        FLOW_A102 = 0;
        FIC_12004 = 0;
      }

      // ✅ VALVE OPEN → FULL FLOW PASSES (NO FAN DEPENDENCY)
      else {
        FIC_12004 = FIC_12009;

        // Optional: still split flow for display (purely visual, not control)
        FLOW_A101 = FIC_12009 * 0.5;
        FLOW_A102 = FIC_12009 * 0.5;
      }




      /* TEMPERATURE TRANSMITTER */
      const TT_12002 = isXV_12001Open ? Number(transmitters?.TT_10501 ?? 0) : 18;

      /* PRESSURE TRANSMITTER */
      const PT_12001 = isXV_12001Open ? Number(transmitters?.PT_10501 ?? 0) : 0.03;
      const PT_12002 = isXV_12001Open ? PT_12001 - (PT_12001 * 0.098) : 0;

        useEffect(() => {
            localStorage.setItem("PT_12001", PT_12001);
          }, [PT_12001]);

      // ===============================
      // 🔷 COOLING MODEL
      // ===============================
      const MAX_COOLING = 80;

      // A-101 outlet temperature → TT_12003
      let TT_12003 = TT_12002;

      if (A101_ON) {
        const coolingA101 = (A101Speed / 100) * MAX_COOLING;
        TT_12003 = Math.max(TT_12002 - coolingA101, 0);
      }

      // A-102 outlet temperature → TT_12004
      let TT_12004 = TT_12002;

      if (A102_ON) {
        const coolingA102 = (A102Speed / 100) * MAX_COOLING;
        TT_12004 = Math.max(TT_12002 - coolingA102, 0);
      }

      // ===============================
      // 🔷 MIXED TEMPERATURE (FOR PRESSURE)
      // ===============================
      let mixedTemp = TT_12002;

      if (!A101_ON && !A102_ON) {
        mixedTemp = TT_12002;
      }
      else if (A101_ON && !A102_ON) {
        mixedTemp = TT_12003;
      }
      else if (!A101_ON && A102_ON) {
        mixedTemp = TT_12004;
      }
      else {
        // weighted by flow (important!)
        mixedTemp =
          (TT_12003 * FLOW_A101 + TT_12004 * FLOW_A102) /
          (FLOW_A101 + FLOW_A102 || 1);
      }

      // ===============================
      // 🔷 PRESSURE (PT_12004)
      // ===============================
      const BASE_PRESSURE = PT_12002;

      const PRESSURE_DROP_FACTOR = 0.025;

      const tempDrop = TT_12002 - mixedTemp;

      const PT_12004 = Math.max(
        BASE_PRESSURE - (tempDrop * PRESSURE_DROP_FACTOR),
        0
      );



      
      
// =================  DECREMENTING CRUDE LEVEL OF FIRST STAGE SEPARATOR CHAMBER =================

      const isXV_12002Open = valves?.XV_12002 === false;

      const crudeFlowRate1stStageSeparator = 300.56
       const FIC_12007 = isXV_12002Open ? crudeFlowRate1stStageSeparator * ((valveData?.FCV_12005?.opening || 0) / 100) : 0;

      const FIC_12007a = isXV_12002Open ? FIC_12007 * 24 : 0;
       const crudeDensity1 = 855.565;
      const FIC_12007b = isXV_12002Open ? (FIC_12007 / 1000 / 60) * crudeDensity1 : 0;

      const TT_12007a = isXV_12002Open ? TT_12002 -(TT_12002 * 0.098) :22;


      const { setTransmitters } = useContext(WellContext);
      useEffect(() => {
        setTransmitters(prev => ({
          ...prev,
          FIC_12007: FIC_12007
        }));
      }, [FIC_12007]);


      // ================= DECREMENTING WATER LEVEL OF FIRST STAGE SEPARATOR CHAMBER =================

      const isXV_12003Open = valves?.XV_12003 === false;

      const waterFlowRate1stStageSeparator = 29.942;
       const FIC_12006 = isXV_12003Open ? (waterFlowRate1stStageSeparator + FIC_12008 * ((valveData?.FCV_12006?.opening || 0) / 100)) : 0;
       const FIC_12006a = isXV_12003Open ? FIC_12006 * 24 : 0;

       const waterDensity1 = 993.565;
      const FIC_12006b = isXV_12003Open ? (FIC_12006 / 1000 / 60) * waterDensity1 : 0;
       
      const TT_12006a = isXV_12003Open ? TT_12002 -(TT_12002 * 0.198) :22;


      useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              FIC_12006: FIC_12006
            }));
          }, [FIC_12006]);

          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              TT_12006a: TT_12006a
            }));
          }, [TT_12006a]);



          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              TT_12007a: TT_12007a
            }));
          }, [TT_12007a]);



          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              PT_12002: PT_12002
            }));
          }, [PT_12002]);


          useEffect(() => {
            localStorage.setItem("FIC_12004", FIC_12004);
          }, [FIC_12004]);

          useEffect(() => {
            localStorage.setItem("PT_12004", PT_12004);
          }, [PT_12004]);

          useEffect(() => {
            localStorage.setItem("TT_12004", TT_12004);
          }, [TT_12004]);

          useEffect(() => {
            localStorage.setItem("TT_12003", TT_12003);
          }, [TT_12003]);
   


  return (
    <div className="FirstStageSeparator-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "320px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2.2px 215px"
      }}>
        FIRST STAGE SEPARATION
      </h2>


    {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-12001 */}
      <Valve
        className="XV-12001"
        tag="XV_12001"
        x={185}
        y={134}
        isClosed={valves.XV_12001}
        toggle={toggleValve}
      />

      {/* XV-12002 */}
      <Valve
        className="XV-12002"
        tag="XV_12002"
        x={550}
        y={417}
        isClosed={valves.XV_12002}
        toggle={toggleValve}
        r={90}
      />

      
      {/* XV-11003 */}
      <Valve
        className="XV-12003"
        tag="XV_12003"
        x={423}
        y={465}
        isClosed={valves.XV_12003}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-12004 */}
      <Valve
        className="XV-12004"
        tag="XV_12004"
        x={1208}
        y={263}
        isClosed={valves.XV_12004}
        toggle={toggleValve}
        r={90}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-12001 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12001"
          style={{ position: "absolute", left: 722, top: 99, transform: "rotate(270deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_12001")}>
          
          <defs>
            <linearGradient id="metal_12001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-12003 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12003"
          style={{ position: "absolute", left: 225, top: 502 }}  onClick={() => openPanel("FCV_12003")}>
          
          <defs>
            <linearGradient id="metal_12003">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12003)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12003)" stroke="#7f8c8d" strokeWidth="2" />

          


        </svg>
        {/* FCV-12004 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12005"
          style={{ position: "absolute", left: 240, top: 655 }}  onClick={() => openPanel("FCV_12004")}>
          
          <defs>
            <linearGradient id="metal_12004">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12004)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12004)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        {/* FCV-12005 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12005"
          style={{ position: "absolute", left: 725, top: 606}}  onClick={() => openPanel("FCV_12005")}>
          
          <defs>
            <linearGradient id="metal_12005">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12005)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12005)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        {/* FCV-12006 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12006"
          style={{ position: "absolute", left: 575, top: 682}}  onClick={() => openPanel("FCV_12006")}>
          
          <defs>
            <linearGradient id="metal_12006">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12006)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12006)" stroke="#7f8c8d" strokeWidth="2" />



        </svg>
        {/* FCV-12002 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12002"
          style={{ position: "absolute", left: 830, top: 151}}  onClick={() => openPanel("FCV_12002")}>
          
          <defs>
            <linearGradient id="metal_12002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12002)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

      
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= ✅ AIR COOLER FACEPLATES ================= */}
          {openCoolerPanels.map((tag, index) => (
            <AirCoolerFaceplate
              key={tag}
              tag={tag}
              close={() => closeCoolerPanel(tag)}
              defaultPosition={{
                x: 400 + index * 40,
                y: 200 + index * 40
              }}
            />
          ))}


      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_12001?.opening || 0)}
        x={778}
        y={114}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12003?.opening || 0)}
        x={250}
        y={543}
      />
      <ValveOutput
        value={Number(valveData?.FCV_12004?.opening || 0)}
        x={265}
        y={697}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12005?.opening || 0)}
        x={750}
        y={656}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12006?.opening || 0)}
        x={600}
        y={727}
      />
      <ValveOutput
        value={Number(valveData?.FCV_12002?.opening || 0)}
        x={850}
        y={195}
      />

    <Transmitter
      value={FIC_12001}
      x={602}
      y={123}
      unit="SCF/S"
      max={300}
      HH={294}
      H={280}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT GAS OUTLET OF 2ND STAGE SEPARATOR TO AIR COOLERS"
      tag="FIC-12001"
    />

    <Transmitter
      value={FIC_12002}
      x={1027}
      y={123}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS FROM TEST SEPARATOR"
      tag="FIC-12002"
    />

    <Transmitter
      value={FIC_12003}
      x={1149}
      y={86}
      unit="SCF/S"
      max={50}
      HH={45}
      H={40}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT 1ST STAGE SEPARATOR PSV OUTLET LINE TO FLARE HEADER"
      tag="FIC-12003"
    />

    <Transmitter
      value={FIC_12009}
      x={752}
      y={181}
      unit="SCF/S"
      max={150}
      HH={145}
      H={140}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS TO INLET OF AIR COOLERS"
      tag="FIC-12009"
    />

    <Transmitter
      value={FIC_12004}
      x={1206}
      y={181}
      unit="SCF/S"
      max={150}
      HH={145}
      H={140}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT DISCHARGE OF TWO AIR COOLERS TO HP COMPRESSOR SUCTION DRUM"
      tag="FIC-12004"
    />
    
    <Transmitter
      value={FIC_13001a}
      x={96}
      y={123}
      unit="BPM"
      max={300}
      HH={294}
      H={280}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM PRODUCTION HEADER-1 TO FIRST STAGE SEPARATOR"
      tag="FIC-12001A"
    />

    <Transmitter
      value={TT_12002}
      x={440}
      y={154}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF 1ST STAGE SEPARATOR VESSEL"
      tag="TT-12002"
     />

    <Transmitter
      value={PT_12001}
      x={350}
      y={154}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF 1ST STAGE SEPARATOR VESSEL"
      tag="PT-12001"
     />

    <Transmitter
      value={PT_12002}
      x={530}
      y={124}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS AT OUTLET OF MAIN GAS LINE FROM 1ST STAGE SEPARATOR VESSEL"
      tag="PT-12002"
     />

    <Transmitter
      value={PT_12003}
      x={940}
      y={124}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS FROM TEST SEPARATOR"
      tag="PT-12003"
     />

      <Transmitter
      value={TT_12003}
      x={1090}
      y={277}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="orange"
      description="TEMPERATURE OF GAS FROM THE DISCHARGE OF A-101A AND A-1O1B AIR COOLER TO HP COMPRESSOR SUCTION DRUM"
      tag="TT-12003"
     />

      <Transmitter
      value={TT_12004}
      x={1090}
      y={489}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="orange"
      description="TEMPERATURE OF GAS FROM THE DISCHARGE OF A-102A AND A-1O2B AIR COOLER TO HP COMPRESSOR SUCTION DRUM"
      tag="TT-12004"
     />

      <Transmitter
      value={PT_12004}
      x={1134}
      y={180}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS FROM THE DISCHARGE OF AIR COOLER TO HP COMPRESSOR SUCTION DRUM"
      tag="PT-12004"
     />

    <Transmitter
      value={FIC_12005}
      x={150}
      y={488}
      unit="LPM"
      max={300}
      HH={294}
      H={280}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER AND SEDIMENTS FROM 1ST STAGE SEPARATOR TO CLOS DRAIN"
      tag="FIC-12005"
    />

    <Transmitter
      value={FIC_12008}
      x={146}
      y={638}
      unit="LPM"
      max={300}
      HH={294}
      H={280}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF REVERSE DEMULSIFIER AGAENT TO PRODUCED WATER LINE GOING TO DE-OILER VESSEL"
      tag="FIC-12008"
    />

    <Transmitter
      value={FIC_12007}
      x={603}
      y={555}
      unit="BPM"
      max={300}
      HH={285}
      H={270}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 1ST STAGE SEPARATOR TO 2ND STATE SEPARATOR"
      tag="FIC-12007"
    />

    <Transmitter
      value={FIC_12007a}
      x={603}
      y={563}
      unit="BPD"
      max={7750}
      HH={7745}
      H={7240}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 1ST STAGE SEPARATOR TO 2ND STATE SEPARATOR"
      tag="FIC-12007A"
    />

    <Transmitter
      value={FIC_12007b}
      x={603}
      y={572}
      unit="kg/m3"
      max={5}
      HH={4.23}
      H={3.8}
      L={0.05}
      LL={0.003}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 1ST STAGE SEPARATOR TO 2ND STATE SEPARATOR"
      tag="FIC-12007B"
    />

    <Transmitter
      value={TT_12007a}
      x={603}
      y={581}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF 1ST STAGE SEPARATOR TO 2ND STATE SEPARATOR"
      tag="TT-12007A"
    />

    <Transmitter
      value={FIC_12006}
      x={453}
      y={555}
      unit="LPM"
      max={20}
      HH={18}
      H={16}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 1ST STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-12006"
    />

    <Transmitter
      value={FIC_12006a}
      x={448}
      y={563}
      unit="LPD"
      max={400}
      HH={385}
      H={350}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 1ST STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-12006A"
    />

    <Transmitter
      value={FIC_12006b}
      x={455}
      y={572}
      unit="kg/m3"
      max={2}
      HH={1.5}
      H={1.8}
      L={0.08}
      LL={0.03}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 1ST STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-12006B"
    />

    <Transmitter
      value={TT_12006a}
      x={455}
      y={581}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF 1ST STAGE SEPARATOR TO DE-OILER VESSEL"
      tag="TT-12006A"
    />


      
      <LevelTransmitterIndicator
      tag="LT_12001"
      level={levels?.LT_12001 || 0}
      totalLevel={10000}
      inflows={[inflow_120]}
      outflows={[FIC_12007/36]}
      responseFactor={0.05}
      columnX={540}
      columnY={230}
      columnWidth={30}
      columnHeight={120}
      textX={635}
      textY={270}
      showFlow={true}
    />

      <LevelTransmitterIndicator
      tag="LT_12002"
      totalLevel={10000}
      inflows={inflows4}
      outflows={[FIC_12006/30]}
      responseFactor={0.05}
      columnX={420}
      columnY={300}
      columnWidth={30}
      columnHeight={120}
      textX={336}
      textY={380}
      showFlow={true}
    />

    <AirCooler
      tag="A-101A"
      x={945}
      y={322}
      rpm={1500}
      size={55}
      bladeCount={7}
      bladeLength={30}
    onClick={() => openCoolerPanel("A-101A")}    />

    <AirCooler
      tag="A-101B"
      x={988}
      y={322}
      rpm={1500}
      size={55}
      bladeCount={7}
      bladeLength={30}
      onClick={() => openCoolerPanel("A-101B")}    />
    
    <AirCooler
      tag="A-102A"
      x={945}
      y={552}
      rpm={1500}
      size={55}
      bladeCount={7}
      bladeLength={30}
    onClick={() => openCoolerPanel("A-102A")}    />

    <AirCooler
      tag="A-102B"
      x={988}
      y={552}
      rpm={1500}
      size={55}
      bladeCount={7}
      bladeLength={30}
      onClick={() => openCoolerPanel("A-102B")}    />

      <Transmitter4
        value={A101Speed}
        x={865}
        y={265}
        c="deepskyblue"
      />

      <Transmitter4
        value={A101RPM}
        x={860}
        y={280}
        c="deepskyblue"
      />
    
      <Transmitter4
        value={A102Speed}
        x={865}
        y={489}
        c="deepskyblue"
      />

      <Transmitter4
        value={A102RPM}
        x={860}
        y={504}
        c="deepskyblue"
      />

      

      
    

    </div>
  );
}

export default FirstStageSeparator;
